const ItemTypes = {
  DRAGGABLE: 'DRAGGABLE',
};

export { ItemTypes };
